export const ACTION_TYPES = {
  APP_UNLOCK: 'APP_UNLOCK',
  PIN_UNLOCK: 'PIN_UNLOCK',
  PIN_FAIL: 'PIN_FAIL',
  UNKNOWN: 'UNKNOWN',
};